<template>
    <footer class="footer">
        <div class="webInfo container clearfix">
            <contact></contact>
            <link-panel v-for="(panel, index) in panels" :key="index" :panel="panel"></link-panel>
            <div class="weixin"><img :src="qrcode" alt="官方公众号" width="120">
                <p>关注“泰迪学社”</p>
            </div>
        </div>
        <copy-right></copy-right>
    </footer>
</template>
<script>
    import Contact from './Contact'
    import CopyRight from './CopyRight'
    import LinkPanel from './LinkPanel'
    import weixinQrcode from '@/pages/frontend/assets/images/weixin.png'
    import {getFooterConfig} from '@/api/index'

    export default {
        name: 'AppFooter',
        components: {
            Contact,
            CopyRight,
            LinkPanel
        },
        data() {
            return {
                qrcode: weixinQrcode,
                panels: []
            }
        },
        created() {
            this.getFooterConfig();
        },
        methods: {
            getFooterConfig() {
                getFooterConfig().then(res => {
                    this.panels = res.data;
                });
            }
        }
    }
</script>
